import Helper from "./Helper";

class Header {
  constructor(config = {}) {
    const {} = config;
    this.body = document.querySelector("body");
    this.content = document.querySelector('.content');
    this.header = document.querySelector('header.header');
    this.firstChild = this.content.firstElementChild.nextElementSibling;
    if(Helper.hasClass(this.firstChild, 'ns-pdf-chapter-title')){
      this.firstChild = this.firstChild.nextElementSibling;
    }
    this.headerImageArrow = document.querySelector('.ns-header-img__arrow');

    const menuToggleSelector = '.js-menu-toggle';
    const menuContainerSelector = '.header__right';
    const searchToggleSelector = ".js-search-toggle";
    const searchFormSelector = ".header__searchform";

    const level0TogglerSelector =
      ".main-menu__item--has-children>.main-menu__link--level-0";
    const level1TogglerSelector =
      ".main-menu__item--has-children>.main-menu__link--level-1";
    this.level0SubmenuSelector = ".main-menu--level-1";
    this.level1SubmenuSelector = ".main-menu--level-2";
    this.searchForm = document.querySelector(searchFormSelector);
    this.level0TogglerArray = Array.prototype.slice.call(
      document.querySelectorAll(level0TogglerSelector)
    );
    this.level1TogglerArray = Array.prototype.slice.call(
      document.querySelectorAll(level1TogglerSelector)
    );
    this.searchToggleArray = Array.prototype.slice.call(
      document.querySelectorAll(searchToggleSelector)
    );
    this.menuToggle = document.querySelector(menuToggleSelector);
    this.menuContainer = document.querySelector(menuContainerSelector);

    this.lockscreen = !!document.querySelector(".lockscreen");

    if(this.header && !this.lockscreen){      
      this.whiteHeaderHandle();
      this.submenuOverflowCheck(this.level0SubmenuSelector);
      this.bindClicks();
      window.addEventListener("scroll", e => {
        this.handleScroll(e);
      });
    }
  }

  bindClicks() {
    if(this.headerImageArrow){
      this.headerImageArrow.addEventListener("click", e => {
        window.scrollTo({top: document.querySelector('.ns-header-img').offsetHeight-80, behavior: 'smooth'});
      });
    }

    this.menuToggle.addEventListener("click", e => {
      if(Helper.hasClass(this.body, 'menu-open')){
        Helper.slideClose(this.menuContainer);
        Helper.removeClass(this.body, 'menu-open');
        Helper.removeClass(this.menuToggle, 'burger-active');
      } else{
        Helper.addClass(this.body, 'menu-open');
        Helper.addClass(this.menuToggle, 'burger-active');
        Helper.slideOpen(this.menuContainer, true);
      }
    });

    this.searchToggleArray.forEach((toggle) => {
      toggle.addEventListener("click", (e) => {
        this.toggleSearch();
        this.closeSubmenu(null, this.level0SubmenuSelector);
      });
    });

    this.level0TogglerArray.forEach((toggler) => {
      toggler.addEventListener("click", (e) => {
        e.preventDefault();
        this.toggleSubmenu(toggler, this.level0SubmenuSelector, true);
      });
    });
    this.level1TogglerArray.forEach((toggler) => {
      toggler.addEventListener("click", (e) => {
        e.preventDefault();
        this.toggleSubmenu(toggler, this.level1SubmenuSelector, false);
      });
    });
  }

  handleScroll(e){
    let scrollTop = document.documentElement.scrollTop;
    const pagination = this.firstChild.querySelector('.swiper-pagination-wrap');
    const swiperHeight = (pagination) ? pagination.offsetHeight : 0;
    // const elHeight = this.firstChild.offsetHeight - swiperHeight;
    const elHeight = 150;

    if(scrollTop <= (elHeight - this.header.offsetHeight) || scrollTop == 0){
      this.whiteHeaderHandle();
      Helper.removeClass(this.header, 'header--shrunk');
    } else {
      Helper.addClass(this.header, 'header--white');
      Helper.addClass(this.header, 'header--shrunk');
    }
  }

  whiteHeaderHandle(){
    if(Helper.hasClass(this.firstChild, 'ns-header-img') || Helper.hasClass(this.firstChild, 'slider--header')){
      Helper.removeClass(this.header, 'header--white');
      Helper.addClass(this.header, 'header--transparent');
    } else {
      Helper.addClass(this.header, 'header--white');
      Helper.removeClass(this.header, 'header--transparent');
    }
  }

  submenuOverflowCheck(subMenuSelector) {
    const submenus = Array.prototype.slice.call(
      document.querySelectorAll(subMenuSelector)
    );

    submenus.forEach((el) => {
      el.style.display = "block"; // Make it visible
      const bounding = el.getBoundingClientRect();
      el.style.display = ""; //  Hide it again
      if (
        bounding.right >
        (window.innerWidth || document.documentElement.clientWidth)
      ) {
        // console.log('Right side is out of viewport');
        Helper.addClass(el, "align-right");
      }
    });
  }

  toggleSearch() {
    if (Helper.hasClass(this.body, "search-open")) {
      this.closeSearch();
    } else {
      this.openSearch();
    }
  }

  openSearch() {
    this.searchToggleArray.forEach((toggle) => {
      Helper.addClass(toggle, "search-active");
    });
    Helper.addClass(this.body, "search-open");
    Helper.addClass(this.searchForm, "is-open");
    Helper.slideOpen(this.searchForm, true);
  }

  closeSearch() {
    this.searchToggleArray.forEach((toggle) => {
      Helper.removeClass(toggle, "search-active");
    });
    Helper.removeClass(this.body, "search-open");
    Helper.removeClass(this.searchForm, "is-open");
    Helper.slideClose(this.searchForm);
  }

  toggleSubmenu(toggler, submenuSelector, closeOthers) {
    // console.log("toggleSubmenu");
    this.closeSearch();
    if (Helper.hasClass(toggler, "is-open")) {
      this.closeSubmenu(toggler);
    } else {
      this.openSubmenu(toggler, submenuSelector, closeOthers);
    }
  }

  openSubmenu(toggler, submenuSelector, closeOthers) {
    // console.log("openSubmenu");
    if (closeOthers) {
      this.closeSubmenu(null, submenuSelector);
    }
    const submenu = toggler.nextElementSibling;
    Helper.addClass(toggler, "is-open");
    Helper.addClass(submenu, "is-open");
    Helper.slideOpen(submenu, true);
  }

  closeSubmenu(toggler = null, submenuSelector = null) {
    // console.log("closeSubmenu");
    if (toggler) {
      // console.log("close with toggler");
      const submenu = toggler.nextElementSibling;
      Helper.removeClass(toggler, "is-open");
      Helper.removeClass(submenu, "is-open");
      Helper.slideClose(submenu);
    }

    if (submenuSelector) {
      // console.log("close with submenuselector");
      Array.prototype.slice
        .call(document.querySelectorAll(submenuSelector))
        .forEach((submenu) => {
          Helper.removeClass(submenu.previousElementSibling, "is-open");
          Helper.removeClass(submenu, "is-open");
          Helper.slideClose(submenu);
        });
    }
  }
}

export default Header;
